import Vetrina from "./Vetrina";

export default Vetrina;
